import type { FC } from "react";

import { FormattedPrice } from "@jti/ui";

import styles from "./ProductEntry.module.scss";

type ProductEntryProps = React.PropsWithChildren<{
  children?: React.ReactNode;
  title: string;
  description?: string;
  price: {
    currency: string;
    value: number;
    currencyCode?: string;
    regularPrice?: number;
  };
  imageUrl?: string;
}>;

const ProductEntry: FC<ProductEntryProps> = ({ children, title, description, imageUrl, price }) => {
  return (
    <>
      <div className={styles.header} data-testid="ProductEntry">
        {imageUrl && (
          <div className={styles.imageContainer}>
            <div
              style={{ backgroundImage: `url(${imageUrl})` }}
              role="img"
              aria-label={title}
              className={styles.image}
            ></div>
          </div>
        )}
        <div className={styles.descriptionContainer}>
          <div className={styles.name}>{title}</div>
          <div className={styles.descriptionAndPrice}>
            {description && <div className={styles.description}>{description}</div>}
            <div className={styles.price}>
              <FormattedPrice value={price.value} currency={price.currency} />
            </div>
          </div>
        </div>
      </div>
      {children}
    </>
  );
};

export default ProductEntry;
